import React from 'react';
import { Apple, Play } from 'lucide-react';
import { useLanguage } from './LanguageContext';

const APPSTORE_URL = (process.env.REACT_APP_APPSTORE_URL || '').trim();
const PLAYSTORE_URL = (process.env.REACT_APP_PLAYSTORE_URL || '').trim();

// When the URL is empty → render a "Coming soon" pill (current behaviour, pre-launch).
// When the URL is set → render a clickable download badge.
//
// theme: "light"  — for hero / cream background  (bg-white)
//        "dark"   — for dark CTA card            (bg-white/10)
export const StoreBadges = ({ theme = 'light', testIdPrefix = 'store' }) => {
  const { t } = useLanguage();

  const items = [
    {
      key: 'appstore',
      url: APPSTORE_URL,
      Icon: Apple,
      live: t.store.appStoreLive,
      soon: t.hero.comingSoonAppStore,
    },
    {
      key: 'playstore',
      url: PLAYSTORE_URL,
      Icon: Play,
      live: t.store.playStoreLive,
      soon: t.hero.comingSoonPlayStore,
    },
  ];

  const baseLight =
    'inline-flex items-center gap-2 px-4 py-2.5 rounded-2xl bg-white border border-stone-200 text-stone-700 text-xs font-semibold transition-all';
  const baseDark =
    'inline-flex items-center gap-2 px-4 py-3 rounded-2xl bg-white/10 border border-white/10 text-white text-xs font-semibold transition-all flex-1';

  const liveLight = ' hover:border-stone-900 hover:-translate-y-0.5 active:scale-[0.98]';
  const liveDark = ' hover:bg-white/20 active:scale-[0.98]';

  return (
    <div
      className={`flex flex-wrap items-center gap-2 ${
        theme === 'dark' ? 'w-full' : ''
      }`}
    >
      {items.map(({ key, url, Icon, live, soon }) => {
        const isLive = Boolean(url);
        const className =
          (theme === 'dark' ? baseDark : baseLight) +
          (isLive ? (theme === 'dark' ? liveDark : liveLight) : ' opacity-90 cursor-default');

        const content = (
          <>
            <Icon className="h-4 w-4 flex-shrink-0" />
            <span>{isLive ? live : soon}</span>
          </>
        );

        return isLive ? (
          <a
            key={key}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`${testIdPrefix}-${key}-link`}
            className={className}
          >
            {content}
          </a>
        ) : (
          <span
            key={key}
            data-testid={`${testIdPrefix}-${key}-soon`}
            className={className}
          >
            {content}
          </span>
        );
      })}
    </div>
  );
};
